import { getPortalId } from '../utils/getPortalId';
import { getExtensionAppId } from '../utils/getExtensionAppId';
import { settingsUrlMappings } from '../constants/SettingsURLMappings';
import getWindow from '../utils/getWindow';
export const replacePlaceholders = path => {
  if (path.includes('**{extensionAppId}**')) {
    return path.replace('**{portalId}**', `${getPortalId()}`).replace('**{extensionAppId}**', `${getExtensionAppId()}`);
  }
  return path.replace('**{portalId}**', `${getPortalId()}`);
};
export const getSettingsPath = () => {
  const windowPath = getWindow().location.pathname;
  const pathParts = /^\/([\w-]+)\/\d+/.exec(windowPath);
  const currentAppPath = pathParts && pathParts.length >= 1 ? pathParts[1] : null;
  const mappingKeys = Object.keys(settingsUrlMappings);
  const result = mappingKeys.reduce((path, type) => {
    if (path !== null) {
      return path;
    }
    const {
      from,
      to
    } = settingsUrlMappings[type];
    const toLink = replacePlaceholders(to);
    if (currentAppPath === from || from instanceof RegExp && from.test(windowPath)) {
      return toLink;
    }
    return path;
  }, null);
  return result;
};
export const useSettingsLink = () => {
  const defaultSettingsLink = `/user-preferences/${getPortalId() || ''}`;
  const settingsLinkForCurrentApp = getSettingsPath();
  const link = settingsLinkForCurrentApp || defaultSettingsLink;
  return `${link}?eschref=${encodeURIComponent(window.location.pathname)}`;
};